import { Injectable } from "@angular/core";
@Injectable({
  providedIn: "root"
})
export class PermissionUrlService {
  constructor() { }
  ADMIN_PERMISSIONS = [
    ".*",
    "^.*$",
    "^\\/.*$"
  ];
  OVERALL_STATUS = [
    ...this.ADMIN_PERMISSIONS
  ];
  OVERALL_PERFORMANCE_OVERALL_OTIF = [
    "^\\/00.*$",
    "^\\/01.*$",
    "^\\/02.*$",
    "^\\/03.*$",
    "^\\/04.*$",
    "^\\/05.*$",
    "^\\/06.*$",
    "^\\/07.*$",
    "^\\/08.*$",
    ...this.ADMIN_PERMISSIONS
  ];
  OVERALL_PERFORMANCE_TAB_DELHIVERY = [
    "^\\/00.*$",
    "^\\/01.*$",
    "^\\/02.*$",
    "^\\/03.*$",
    "^\\/04.*$",
    "^\\/05.*$",
    "^\\/06.*$",
    "^\\/07.*$",
    "^\\/08.*$",
    ...this.ADMIN_PERMISSIONS
  ];
  HIGHLIGHT_OVERALL_PERFORMANCE = ["^\\/00.*$", ...this.ADMIN_PERMISSIONS];
  YESTERDAY_OTIF_PERMISSION = ["^\\/00.*$", ...this.ADMIN_PERMISSIONS];
  MONTH_TO_DATE_OTIF = ["^\\/01.*$", ...this.ADMIN_PERMISSIONS];
  QUARTER_TO_DATE_OTIF = ["^\\/02.*$", ...this.ADMIN_PERMISSIONS];
  OVERALL_OTIF_PERMISSION = ["^\\/03.*$", ...this.ADMIN_PERMISSIONS];
  OTIF_TRENDS_PERMISSION = ["^\\/04.*$", ...this.ADMIN_PERMISSIONS];
  REASON_FAILURE_PERMISSION = ["^\\/05.*$", ...this.ADMIN_PERMISSIONS];
  REGIONWISE_OTF_BREAKUP = ["^\\/06.*$", ...this.ADMIN_PERMISSIONS];
  MOST_AFFECTED_STATES = ["^\\/07.*$", ...this.ADMIN_PERMISSIONS];
  MOST_AFFECTED_CUSTOMERS = ["^\\/08.*$", ...this.ADMIN_PERMISSIONS];
  TRANSFER_YESTERDAY_SLA = ["^\\/10.*$", ...this.ADMIN_PERMISSIONS];
  TRANSFER_MONTH_TO_DATE = ["^\\/11.*$", ...this.ADMIN_PERMISSIONS];
  TRANSFER_QUARTER_TO_DATE_OTIF = [
    "^\\/12.*$", ...this.ADMIN_PERMISSIONS
  ];
  TRANSFER_END_TO_END_SLA = ["^\\/13.*$", ...this.ADMIN_PERMISSIONS];
  TRANSFER_END_TO_END_SLA_TREND = [
    "^\\/14.*$", ...this.ADMIN_PERMISSIONS
  ];
  TRANSFER_REASONS_OF_FAILURE = [
    "^\\/15.*$", ...this.ADMIN_PERMISSIONS
  ];
  TRANSFER_WORST_OD_PAIRS = ["^\\/16.*$", ...this.ADMIN_PERMISSIONS];
  INWARD_YESTERDAY_SLA = ["^\\/18.*$", ...this.ADMIN_PERMISSIONS];
  INWARD_MONTH_TO_DATE_SLA = ["^\\/19.*$", ...this.ADMIN_PERMISSIONS];
  INWARD_QUARTER_TO_DATE_SLA = [
    "^\\/20.*$", ...this.ADMIN_PERMISSIONS
  ];
  INWARD_END_TO_END_SLA = ["^\\/21.*$", ...this.ADMIN_PERMISSIONS];
  INWARD_END_TO_END_SLA_TREND = [
    "^\\/22.*$", ...this.ADMIN_PERMISSIONS
  ];
  INWARD_REASON_FOR_FAILURE = ["^\\/23.*$", ...this.ADMIN_PERMISSIONS];
  INWARD_WORST_OD_PAIRS = ["^\\/24.*$", ...this.ADMIN_PERMISSIONS];
  RETURN_YESTERDAY_SLA = ["^\\/26.*$", ...this.ADMIN_PERMISSIONS];
  RETURN_MONTH_TO_DATE_SLA = ["^\\/27.*$", ...this.ADMIN_PERMISSIONS];
  RETURN_QUARTER_TO_DATE_SLA = [
    "^\\/28.*$", ...this.ADMIN_PERMISSIONS
  ];
  RETURN_END_TO_END_SLA = ["^\\/29.*$", ...this.ADMIN_PERMISSIONS];
  RETURN_WORST_OD_PAIRS = ["^\\/32.*$", ...this.ADMIN_PERMISSIONS];
  TRANSPORTATION_YESTERDAY_SLA = [
    "^\\/42.*$", ...this.ADMIN_PERMISSIONS
  ];
  TRANSPORTATION_MONTH_TO_DATE = [
    "^\\/43.*$", ...this.ADMIN_PERMISSIONS
  ];
  TRANSPORTATION_QUARTER_TO_DATE = [
    "^\\/44.*$", ...this.ADMIN_PERMISSIONS
  ];
  TRANSPORTATION_SLA = ["^\\/45.*$", ...this.ADMIN_PERMISSIONS];
  TRANSPORTATION_SLA_TREND = ["^\\/46.*$", ...this.ADMIN_PERMISSIONS];
  TRANSPORTATION_MOST_AFFECTED_OD_PAIR = [
    "^\\/47.*$", ...this.ADMIN_PERMISSIONS
  ];
  TRANSPORTATION_TAT_BREAKUP = [
    "^\\/48.*$", ...this.ADMIN_PERMISSIONS
  ];
  TRANSPORTATION_POD_BREAKUP = [
    "^\\/49.*$", ...this.ADMIN_PERMISSIONS
  ];
  TRANSPORTATION_DAMAGE_SHORTAGE = [
    "^\\/e2e\\/transportation\\/damage-shortage\\:GET$"
  ];
  TRANSPORTATION_ECOMMERCE_RETURN = [
    "^\\/e2e\\/transportation\\/e-commerce\\/return\\:GET$"
  ];
  TRANSPORTATION_TEMPRATURE_ADHERENCE = [
    "^\\e2e\\/transportation\\/temprature-adherence\\:GET$"
  ];

  TRANSPORTATION_SLA_TREND_V3 = ['^\\/cn.*$', ...this.ADMIN_PERMISSIONS ];
  TRANSPORTATION_DELIVERY_ATTEMPT_SLA = ['^\\/co.*$', ...this.ADMIN_PERMISSIONS ];
  TRANSPORTATION_MOST_AFFECTED_OD = ['^\\/cp.*$', ...this.ADMIN_PERMISSIONS ];

  WAREHOUSE_YESTERDAY_SLA = ["^\\/34.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_MONTH_TO_DATE_OTIF = [
    "^\\/35.*$", ...this.ADMIN_PERMISSIONS
  ];
  WAREHOUSE_QUARTER_TO_DATE_OTIF = [
    "^\\/36.*$", ...this.ADMIN_PERMISSIONS
  ];
  WAREHOUSE_SLA = ["^\\/37.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_SLA_TREND = ["^\\/38.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_MOST_AFFECTED = ["^\\/39.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_UTILIZATION = ["^\\/40.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_INVENTORY_TREND = ["^\\/bx.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_INVENTORY_FILL_RATE = ["^\\/by.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_INVENTORRY_ANALYSIS = ["^\\/bz.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_OVERALL_TEMPRATURE_ADHERENCE = [
    "^\\/e2e\\/warehouse\\/temprature-adherence\\:GET$"
  ];

  WAREHOUSE_OUTBOUND_SLA = ["^\\/cl.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_OUTBOUND_REGIONAL_SLA = ["^\\/cc.*$", ...this.ADMIN_PERMISSIONS];

  WAREHOUSE_OUTBOUND_SLA_TREND = ["^\\/cb.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_OUTBOUND_MOST_AFFECTED = ["^\\/cd.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_OUTBOUND_BEST_PERFORMING = ["^\\/cd.*$", ...this.ADMIN_PERMISSIONS];

  WAREHOUSE_OUTBOUND_HIGHLIGHTS = [
    "^\\/ca.*$", ...this.ADMIN_PERMISSIONS
  ];

  WAREHOUSE_INBOUND_SLA_TREND = ["^\\/cf.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_INBOUND_SLA = ["^\\/cg.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_INBOUND_SLA_REGION = ["^\\/cg.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_INBOUND_MOST_AFFECTED = ["^\\/ch.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_INBOUND_MOST_AFFECTED_PRODUCT = ["^\\/ci.*$", ...this.ADMIN_PERMISSIONS];
  WAREHOUSE_INBOUND_HIGHLIGHTS = [
    "^\\/ce.*$", ...this.ADMIN_PERMISSIONS
  ];

  WAREHOUSE_OUTBOUND = [
    ...this.WAREHOUSE_OUTBOUND_SLA,
    ...this.WAREHOUSE_OUTBOUND_SLA_TREND,
    ...this.WAREHOUSE_OUTBOUND_MOST_AFFECTED,
    ...this.WAREHOUSE_OUTBOUND_BEST_PERFORMING,
    ...this.WAREHOUSE_OUTBOUND_HIGHLIGHTS,
    ...this.WAREHOUSE_OUTBOUND_REGIONAL_SLA
  ];

  WAREHOUSE_INBOUND = [
    ...this.WAREHOUSE_INBOUND_SLA_TREND,
    ...this.WAREHOUSE_INBOUND_SLA,
    ...this.WAREHOUSE_INBOUND_MOST_AFFECTED,
    ...this.WAREHOUSE_INBOUND_MOST_AFFECTED_PRODUCT,
    ...this.WAREHOUSE_INBOUND_HIGHLIGHTS,
  ];

  WAREHOUSE_LEVEL_TEMPRATURE_ADHERENCE = [
    "^\\/e2e\\/warehouse\\/level\\/temprature-adherence\\:GET$"
  ];
  WAREHOUSE_DAMAGE = ["^\\/e2e\\/warehouse\\/damage\\:GET$"];
  WAREHOUSE_INVENTORY_AUDIT_ACCURACY = [
    "^\\/e2e\\/warehouse\\/inventory\\/audit\\/accuracy\\:GET$"
  ];

  WAREHOUSE_INVENTORY = [...this.WAREHOUSE_INVENTORY_TREND,
    ...this.WAREHOUSE_INVENTORY_FILL_RATE,
    ...this.WAREHOUSE_INVENTORRY_ANALYSIS]

  OVERALL_PERFORMANCE_TAB_TRANSFER = [
    ...this.TRANSFER_END_TO_END_SLA,
    ...this.TRANSFER_END_TO_END_SLA_TREND,
    ...this.TRANSFER_MONTH_TO_DATE,
    ...this.TRANSFER_REASONS_OF_FAILURE,
    ...this.TRANSFER_WORST_OD_PAIRS,
    ...this.TRANSFER_YESTERDAY_SLA,
    ...this.TRANSFER_QUARTER_TO_DATE_OTIF,
    ...this.ADMIN_PERMISSIONS
  ];
  OVERALL_PERFORMANCE_TAB_INWARD = [
    ...this.INWARD_END_TO_END_SLA,
    ...this.INWARD_END_TO_END_SLA_TREND,
    ...this.INWARD_MONTH_TO_DATE_SLA,
    ...this.INWARD_QUARTER_TO_DATE_SLA,
    ...this.INWARD_REASON_FOR_FAILURE,
    ...this.ADMIN_PERMISSIONS
  ];
  OVERALL_PERFORMANCE_TAB_RETURN = [
    ...this.RETURN_END_TO_END_SLA,
    ...this.RETURN_MONTH_TO_DATE_SLA,
    ...this.RETURN_QUARTER_TO_DATE_SLA,
    ...this.RETURN_WORST_OD_PAIRS,
    ...this.RETURN_YESTERDAY_SLA,
    ...this.ADMIN_PERMISSIONS
  ];
  WAREHOUSE_PAGE = [
    ...this.WAREHOUSE_QUARTER_TO_DATE_OTIF,
    ...this.WAREHOUSE_DAMAGE,
    ...this.WAREHOUSE_INVENTORY_AUDIT_ACCURACY,
    ...this.WAREHOUSE_LEVEL_TEMPRATURE_ADHERENCE,
    ...this.WAREHOUSE_MONTH_TO_DATE_OTIF,
    ...this.WAREHOUSE_MOST_AFFECTED,
    ...this.WAREHOUSE_OVERALL_TEMPRATURE_ADHERENCE,
    ...this.WAREHOUSE_QUARTER_TO_DATE_OTIF,
    ...this.WAREHOUSE_SLA,
    ...this.WAREHOUSE_SLA_TREND,
    ...this.WAREHOUSE_UTILIZATION,
    ...this.WAREHOUSE_YESTERDAY_SLA,
    ...this.WAREHOUSE_OUTBOUND,
    ...this.WAREHOUSE_INBOUND,
    ...this.WAREHOUSE_INVENTORY,
    ...this.ADMIN_PERMISSIONS
  ]
  TRANSPORTATION_PAGE = [
    ...this.TRANSPORTATION_YESTERDAY_SLA,
    ...this.TRANSPORTATION_MONTH_TO_DATE,
    ...this.TRANSPORTATION_QUARTER_TO_DATE,
    ...this.TRANSPORTATION_SLA,
    ...this.TRANSPORTATION_SLA_TREND,
    ...this.TRANSPORTATION_MOST_AFFECTED_OD_PAIR,
    ...this.TRANSPORTATION_TAT_BREAKUP,
    ...this.TRANSPORTATION_POD_BREAKUP,
    ...this.TRANSPORTATION_DAMAGE_SHORTAGE,
    ...this.TRANSPORTATION_ECOMMERCE_RETURN,
    ...this.TRANSPORTATION_TEMPRATURE_ADHERENCE,
    ...this.ADMIN_PERMISSIONS
  ];

  OVERALL_STATUS_PAGE_HIGHLIGHT_WIDGET = ['^\\/as.*$', ...this.ADMIN_PERMISSIONS];
  OVERALL_STATUS_PAGE_CUMULATIVE_STATUS = ['^\\/as.*$', ...this.ADMIN_PERMISSIONS];
  OVERALL_STATUS_PAGE_STATUS_BREAKUP = ['^\\/av.*$', ...this.ADMIN_PERMISSIONS];
  OVERALL_STATUS_PAGE_REGION_WISE = ['^\\/at.*$', ...this.ADMIN_PERMISSIONS];
  OVERALL_STATUS_PAGE_STATUS_TREND = ['^\\/au.*$', ...this.ADMIN_PERMISSIONS];
  OVERALL_STATUS_PAGETREND_AT_GLANCE = ['^\\/ck.*$', ...this.ADMIN_PERMISSIONS];
  OVERALL_STATUS_PAGE = [...this.OVERALL_STATUS_PAGE_CUMULATIVE_STATUS, ...this.OVERALL_STATUS_PAGE_HIGHLIGHT_WIDGET, ...this.OVERALL_STATUS_PAGE_STATUS_BREAKUP,
  ...this.OVERALL_STATUS_PAGE_REGION_WISE, ...this.OVERALL_STATUS_PAGE_STATUS_TREND, ...this.ADMIN_PERMISSIONS,
  ...this.OVERALL_STATUS_PAGETREND_AT_GLANCE];

  MOVEMENT_DETAIL_DELIVERY_TAB = ["^\\/59.*$", ...this.ADMIN_PERMISSIONS];
  MOVEMENT_DETAIL_TRANSFER_TAB = ["^\\/60.*$", ...this.ADMIN_PERMISSIONS];
  MOVEMENT_DETAIL_INWARD_TAB = ["^\\/61.*$", ...this.ADMIN_PERMISSIONS];
  MOVEMENT_DETAIL_RETURN_TAB = ["^\\/62.*$", ...this.ADMIN_PERMISSIONS];

  MOVEMENT_DETAILS_BULK_POD_DOWNLOAD = ["^\\/az.*$", ...this.ADMIN_PERMISSIONS]

  MOVEMENT_DETAIL_PAGE = [
    "^\\/58.*$",
    ...this.MOVEMENT_DETAIL_DELIVERY_TAB,
    ...this.MOVEMENT_DETAILS_BULK_POD_DOWNLOAD,
    ...this.MOVEMENT_DETAIL_TRANSFER_TAB,
    ...this.MOVEMENT_DETAIL_INWARD_TAB,
    ...this.MOVEMENT_DETAIL_RETURN_TAB,
    ...this.ADMIN_PERMISSIONS
  ];

  INVENTORY_DETAIL_PAGE = ["^\\/57.*$", ...this.ADMIN_PERMISSIONS];

  SALESFORECAST_RTF_UPLOAD_BUTTON = ["^\\/ba.*$", ...this.ADMIN_PERMISSIONS];
  SALESFORECAST_RTF_DOWNLOAD_BUTTON = ["^\\/bb.*$", ...this.ADMIN_PERMISSIONS];
  SALESFORECAST_UPLOAD_BUTTON = ["^\\/96.*$", ...this.ADMIN_PERMISSIONS];
  SALESFORECAST_DOWNLOAD_BUTTON = ["^\\/95.*$", ...this.ADMIN_PERMISSIONS];


  SALESFORECAST_PERMISSION_PAGE = [
    "^\\/98.*$",
    "^\\/99.*$",
    "^\\/92.*$",
    "^\\/93.*$",
    "^\\/94.*$",
    ...this.SALESFORECAST_RTF_UPLOAD_BUTTON,
    ...this.SALESFORECAST_RTF_DOWNLOAD_BUTTON,
    ...this.SALESFORECAST_UPLOAD_BUTTON,
    ...this.SALESFORECAST_DOWNLOAD_BUTTON,
    ...this.ADMIN_PERMISSIONS
  ];
  REGION_WISE_DETAIL = [...this.ADMIN_PERMISSIONS];


  PICKUP_PERMISSION_LIST = ["^\\/ag.*$", ...this.ADMIN_PERMISSIONS];
  PICKUP_PERMISSION_CREATE = ["^\\/af.*$", ...this.ADMIN_PERMISSIONS];
  PICKUP_PERMISSION_EDIT_BUTTON = ["^\\/ak.*$", ...this.ADMIN_PERMISSIONS];
  PICKUP_PERMISSION_APPROVE_BUTTON = ["^\\/an.*$", ...this.ADMIN_PERMISSIONS];
  PICKUP_PERMISSION_CANCEL_BUTTON = ["^\\/am.*$", ...this.ADMIN_PERMISSIONS];
  PICKUP_CREATE_BUTTON = ["^\\/af.*$", ...this.ADMIN_PERMISSIONS];
  PICKUP_START_DISPATCH_BUTTON = ["^\\/ao.*$", ...this.ADMIN_PERMISSIONS];
  PICKUP_SHIPMENT_DISPATCH_BUTTON = ["^\\/ap.*$", ...this.ADMIN_PERMISSIONS];
  PICKUP_SHIPMENT_CANCEL_BUTTON = ["^\\/aq.*$", ...this.ADMIN_PERMISSIONS];
  PICKUP_INVOICE_DOWNLOAD_BUTTON = ["^\\/ar.*$", ...this.ADMIN_PERMISSIONS];
  PICKUP_ON_HOLD_BUTTON = ["^\\/cj.*$", ...this.ADMIN_PERMISSIONS];
  GETUSER_DETAILS = ["^\\/cm.*$", ...this.ADMIN_PERMISSIONS];

  USER_MANAGEMENT = ["telescope-ums"];

  PICKUP_PAGE_PERMISSIONS = [...this.PICKUP_PERMISSION_LIST,
  ...this.PICKUP_PERMISSION_CREATE,
  ...this.PICKUP_PERMISSION_EDIT_BUTTON,
  ...this.PICKUP_PERMISSION_APPROVE_BUTTON,
  ...this.PICKUP_PERMISSION_CANCEL_BUTTON,
  ...this.PICKUP_CREATE_BUTTON,
  ...this.PICKUP_START_DISPATCH_BUTTON,
  ...this.PICKUP_SHIPMENT_DISPATCH_BUTTON,
  ...this.PICKUP_SHIPMENT_CANCEL_BUTTON,
  ...this.PICKUP_INVOICE_DOWNLOAD_BUTTON,
  ...this.PICKUP_ON_HOLD_BUTTON,
  ...this.GETUSER_DETAILS,
  ...this.ADMIN_PERMISSIONS];

  
  FRESH_DESK_ALL = ["^\\/aZ.*$", ...this.ADMIN_PERMISSIONS]
  FRESH_DESK_PERMISSIONS = [...this.FRESH_DESK_ALL,
  this.ADMIN_PERMISSIONS];
  
  CLIENT_MANAGEMENT = ["telescope-cms"];

  CLIENT_PRODUCT_DIVISION_CSV_UPLOAD = ["^\\/bv.*$", ...this.ADMIN_PERMISSIONS];
  CLIENT_FACILITY_CSV_UPLOAD = ["^\\/bu.*$", ...this.ADMIN_PERMISSIONS];

  CLIENT_UMS_UUID_EDIT = ["^\\/br.*$", ...this.ADMIN_PERMISSIONS];

  DOWNLOAD_REPORTS = ["^\\/bs.*$", ...this.ADMIN_PERMISSIONS];

}
